import moment from 'moment';
import { Day as AdventDay, Day } from './types';

export const dateStr = (date: moment.Moment): string => date.format('YYYY-MM-DD');
export const dayByDate = (days: Day[], date: string): Day | undefined => days.find((d) => d.date === date);
export const dayOfMonth = (date: string): string => (+date.substring(8)).toString();
export const currentDateStr = (): string => dateStr(moment.utc());

export const isDeposited = (day: AdventDay): boolean => !!day.offer;
export const isRewarded = (day: AdventDay): boolean => !!day.choice;
export const isPast = (day: AdventDay): boolean => moment.utc(day.date).isBefore(moment.utc(), 'day');
export const isCurrent = (day: AdventDay): boolean => day.date === currentDateStr();
export const isSelectable = (day: AdventDay): boolean => isRewarded(day) || isCurrent(day);

export const currentDay = (days: Day[]): Day | undefined => dayByDate(days, currentDateStr());
